import useNLTrackers from './useNLTrackers';
import useAdobeLaunchTracker from './useAdobeLaunchTracker';

const useTrackers = () => {
	useNLTrackers();
	useAdobeLaunchTracker();
};

export default useTrackers;
